/**
 * Менеджер агрегированного счётчика фильтров (badge).
 * Объединяет значения от нескольких FilterWidget,
 * использующих общий badgeHost.
 */
class FilterBadgeManager {
    /** Получить или создать менеджер для badgeHost */
    static getOrInit(host) {
        let inst = this.instances.get(host);
        if (!inst) {
            inst = new FilterBadgeManager(host);
            this.instances.set(host, inst);
        }
        return inst;
    }
    /** Создаётся только через getOrInit */
    constructor(host) {
        this.host = host;
        /** Количество активных фильтров по источникам */
        this.counts = new Map();
    }
    /** Обновить вклад источника и вернуть суммарное значение */
    update(sourceKey, count) {
        if (count > 0)
            this.counts.set(sourceKey, count);
        else
            this.counts.delete(sourceKey);
        return this.render();
    }
    /** Удалить вклад источника и вернуть суммарное значение */
    remove(sourceKey) {
        this.counts.delete(sourceKey);
        return this.render();
    }
    /** Пересчитать сумму и обновить отображение */
    render() {
        let total = 0;
        for (const v of this.counts.values())
            total += v;
        this.host.textContent = total > 0 ? ` (${total})` : "";
        return total;
    }
}
/** Реестр менеджеров по DOM-хосту (один host → один менеджер) */
FilterBadgeManager.instances = new WeakMap();

export { FilterBadgeManager };
